// bookmarksEvents — a tiny in-app pub/sub so any favorite (bookmark) mutation
// notifies every open view. The favorites nav list subscribes and re-fetches, so
// favoriting a page from the subheader/article heart is reflected immediately
// without a manual refresh. Emitted from bookmarksService after a successful
// add/remove/toggle.
const listeners = new Set();

export const subscribeBookmarksChanged = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

export const emitBookmarksChanged = () => {
  listeners.forEach((cb) => {
    try {
      cb();
    } catch (e) {
      console.error("bookmarks change listener error:", e);
    }
  });
};
